export default {
      id: "expand-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#expand",
      toString: function () {
        return this.url;
      }
    }